import { serverUrl } from '../request'

const ALLOWED_WIDTHS = [64, 128, 240, 360, 480, 640, 800, 1024, 1280, 1600, 1920] as const

export type ImageWidth = (typeof ALLOWED_WIDTHS)[number]

export function imageUrl(image: string | undefined | null, w: ImageWidth): string {
  if (!image) return ''
  return `${serverUrl}${image}?w=${w}`
}

export function imageSrcSet(
  image: string | undefined | null,
  widths: ImageWidth[],
): string {
  if (!image) return ''
  return widths.map((w) => `${serverUrl}${image}?w=${w} ${w}w`).join(', ')
}

export function imageLqip(image: string | undefined | null): string {
  if (!image) return ''
  return `${serverUrl}${image}?w=64&q=40`
}
